import React, { useEffect } from "react";
import { useUsuario, UsuarioProvider } from "../Hooks/UsuarioHook";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import { Login } from "../Pages/Autenticacao/Login";
import { Home } from "../Pages/App/Home";
import { Menu } from "../Components/Menu";
import { app_base_url } from "../Utils/Urls";
import { Guias } from "../Pages/App/Guias";
import { GuiasProvider } from "../Storage/guias";
import { HomeNaoAutenticada } from "../Pages/Autenticacao/HomeNaoAutenticada/HomeNaoAutenticada";
import { EntidadeProvider } from "../Hooks/EntidadeHook";

export const Rotas = () => {
  const { usuario } = useUsuario();
  useEffect(() => {
    console.log(usuario);
  }, [usuario]);
  return (
    <EntidadeProvider>
      <Router>
        {/* {usuario && usuario.usuario && <Menu />} */}
        <GuiasProvider>
          <Routes>
            {/* {usuario && usuario.usuario ? (
          <>
          <Route path={`/${app_base_url}/guias`} element={<Guias />} />
          <Route path="/*" element={<Home />} />
          </>
        ) : (
          // Se não estiver autenticado, mostra a tela de Login
          <>
            <Route path="/home-nao-autenticada" element={<HomeNaoAutenticada />} />
            <Route path="*" element={<Navigate to="/home-nao-autenticada" replace />} />
          </>
        )} */}

            <Route path={`/${app_base_url}/:banco`} element={<HomeNaoAutenticada />} />
            {/* <Route path="*" element={<Navigate to="/home-nao-autenticada" replace />} /> */}
          </Routes>
        </GuiasProvider>
      </Router>
    </EntidadeProvider>
  );
};
